var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAutocomplete',{attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"items":_vm.questionTypes,"item-text":"value","item-value":"value","hide-details":"","clearable":_vm.isClearable,"returnObject":false},model:{value:(_vm.level),callback:function ($$v) {_vm.level=$$v},expression:"level"}})
}
var staticRenderFns = []

export { render, staticRenderFns }